// Build configuration
const BUILD_CONFIG = {
    // Sjekker om superadmin-funksjonalitet skal inkluderes i bygget
    // Denne verdien settes under bygging via .env-filen
    INCLUDE_SUPERADMIN: import.meta.env.VITE_INCLUDE_SUPERADMIN === 'true'
};

// Hjelpefunksjon for å sjekke om superadmin-funksjonalitet er inkludert
export function isSuperAdminEnabled(): boolean {
    return BUILD_CONFIG.INCLUDE_SUPERADMIN;
}
